import React, { Component } from 'react';
import { Modal, Input, Radio, Spin, message } from 'antd';
import ExportUtil from '../../../../common/ExportUtil';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import { element } from 'prop-types';

const RadioGroup = Radio.Group;

class Approve extends Component {
    state = {
        loading: false,
        visible: false,
        fileList: [],
        record: {},
        data: {},
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadedFileList(
                this.loadContractFileList(),
                this.loadCurrentFileList()
            );
        });
    }

    hide = () => {
        this.setState({
            data: {},
            fileList: [],
            visible: false,
        });
    }

    // 处理合同附件、当前附件
    loadedFileList = (...promises) => {
        Promise.all(promises).then(res => {
            // 兼容360
            const flat = [].flat ? [].flat : [].flatten;
            const fileList = flat.call(res || []);
            this.setState({ fileList });
        }).catch(error => {
            console.error(error);
        })
    }

    loadContractFileList = () => {
        const { record: { investigationJdeContractId } } = this.state;
        return Fetch.post(API_URL.contract.queryJdeCodeEnclosure, {
            investigationJdeContractId,
        }).then(res => {
            const fileList = res.data || [];
            fileList.forEach((item, index) => {
                item.uid = item.id;
            });
            return fileList;
        });
    }

    loadCurrentFileList = () => {
        const { record: { investigationJdeContractModifyApplyId } } = this.state;
        return Fetch.post(API_URL.contract.queryEnclosureFileByType, {
            relatedId: investigationJdeContractModifyApplyId,
            fileType: 'CONTRACT_MODIFY',
        }).then(res => {
            const fileList = res.data || [];
            fileList.forEach((item, index) => {
                item.uid = item.fileMateId;
            });
            return fileList;
        });
    }

    submit = () => {
        const { data, record } = this.state;
        const { approvalStatus, comments } = data;
        const { investigationJdeContractModifyApplyId } = record;

        if (!approvalStatus) {
            message.warning('请选择审批结论！');
            return;
        } else if ((approvalStatus === 'DISAGREE' || approvalStatus === 'REJECT') && !comments) {
            message.warning(approvalStatus === 'DISAGREE' ? '请填写审批不通过原因！' : '请填写拒绝原因！');
            return;
        }

        this.setState({ loading: true });
        Fetch.post(API_URL.contract.finApprovalInvestigationJdeContractModifyApply, {
            ...data,
            investigationJdeContractModifyApplyId
        }).then(res => {
            message.success(res.success);
            this.setState({ loading: false }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    handleInputChange = (e, key) => {
        const { data } = this.state;
        data[key] = e.target.value;
        if (key === 'approvalStatus') {
            data.comments = undefined;
        }
        this.setState({ data });
    }

    getContent = () => {
        const {
            data,
            record,
            fileList,
        } = this.state;
        const {
            investigationName,
            investigationJdeContractCode,
            fieldType,
            fieldTypeName,
            oldValue,
            oldList,
            newValue,
            newList,
            baUserName,
            baUserCode,
            reason
        } = record;
        const { approvalStatus, comments } = data;
        const asterisk = <span style={{color: 'red'}}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">项目简称:</div>
                    <div className="item-right">
                        {investigationName}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">JDE项目号:</div>
                    <div className="item-right">
                        {investigationJdeContractCode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">变更字段:</div>
                    <div className="item-right">
                        {fieldTypeName}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">变更前:</div>
                    <div className="item-right">
                        {oldValue?oldValue:oldList?oldList.map((el)=>{
                            return (<div key={el.fileMetaId}><a onClick={e => this.downLoadFile(e,el.fileMetaId )}>{el.fileName}</a></div>)
                        }):''}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">变更后:</div>
                    <div className="item-right">
                        {newValue?newValue:newList?newList.map((el)=>{
                            return (<div key={el.fileMetaId}><a onClick={e => this.downLoadFile(e,el.fileMetaId )}>{el.fileName}</a></div>)
                        }):''}
                    </div>
                </li>
                {
                    fieldType === 'customerCompany' &&
                    <li className="modal-item">
                        <div className="item-left">BA:</div>
                        <div className="item-right">
                            {baUserName ? `${baUserName}（${baUserCode}）` : ''}
                        </div>
                    </li>
                }
                <li className="modal-item">
                    <div className="item-left">变更原因:</div>
                    <div className="item-right">
                        {reason}
                    </div>
                </li>
                {
                    (fieldTypeName !=='合同附件') && 
                    (<li className="modal-item" >
                    <div className="item-left">附件:</div>
                    <div className="item-right">
                        {fileList.map(i => <a key={i.uid} onClick={e => this.downLoadFile(e, i.uid)}>{i.name}<br/></a>)}
                    </div>
                    </li>)
                }
                <li className="modal-item" style={{ borderTop: '1px solid #f1f1f1' }}>
                    <div className="item-left">{asterisk}审批结论:</div>
                    <div className="item-right">
                        <RadioGroup onChange={e => this.handleInputChange(e, 'approvalStatus')} value={approvalStatus}>
                            <Radio value='AGREE'>审批通过</Radio>
                            <Radio value='DISAGREE'>审批不通过</Radio>
                            <Radio value='REJECT'>拒绝变更</Radio>
                        </RadioGroup>
                    </div>
                </li>
                {
                    (approvalStatus === 'DISAGREE' || approvalStatus === 'REJECT') &&
                    <li className="modal-item">
                        <div className="item-left">{approvalStatus === 'DISAGREE' ? "审批不通过原因" : '拒绝原因'}</div>
                        <div className="item-right">
                            <Input
                                maxLength="255"
                                value={comments}
                                placeholder="请填写"
                                style={{width: 300}}
                                onChange={e => this.handleInputChange(e, 'comments')}
                            />
                        </div>
                    </li>
                }
            </ul>
        );
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="审批申请"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <Spin spinning={loading}>
                        { this.getContent() }
                    </Spin>
                </div>
            </Modal>
        ); 
    }
}

export default Approve;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractInfoChange/components/Approve.js